import React from 'react';

import LikeButtonUI from '@travel/ui/components/LikeButton';
import type { LikeIconStyle } from '@travel/ui/components/LikeButton/LikeIcon';

export type Props = {
  className?: string;
  likeIconClassName?: string;
  buttonClassName?: string;
  /** flag to define `like` status */
  isLiked: boolean;
  /** size of like icon */
  likeIconSize: number;
  /** callback function when icon is clicked */
  onClick: (event: React.MouseEvent | React.KeyboardEvent<HTMLDivElement>) => void;
  /** callback function when key is pressed on icon */
  onKeyDown?: React.KeyboardEventHandler;
  /** true if we will need the gold version */
  iconStyle?: LikeIconStyle;
};

function LikeButton(props: Props) {
  return <LikeButtonUI {...props} />;
}

export default LikeButton;
